class MacPCView {
  constructor() {
    this.load()
  }

  load() {
    var isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0
    if (isMac) {
      $(".d-pc").remove()
    } else {
      $(".d-mac").remove()
    }

    var isIpad =
      navigator.userAgent.match(/Mac/) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2

    if (isIpad) {
      $(".d-ipad-block")
        .addClass("d-sm-block")
        .addClass("d-md-block")
        .addClass("d-lg-block")
        .removeClass("d-sm-none")
        .removeClass("d-md-none")
        .removeClass("d-lg-none")
        .removeClass("d-none")
      $(".d-ipad-none").addClass("d-none").removeClass("d-sm-table-cell")
      $(".d-ipad-table-cell")
        .addClass("d-sm-table-cell")
        .addClass("d-md-table-cell")
        .addClass("d-lg-table-cell")
        .removeClass("d-sm-none")
        .removeClass("d-md-none")
        .removeClass("d-lg-none")
        .removeClass("d-none")
    }

    var iOsVersionMatch = /Version\/(\d+)/.exec(navigator.userAgent)
    var iOsVersion = iOsVersionMatch ? parseInt(iOsVersionMatch[1]) : ""

    if (iOsVersion < 13) {
      $(".d-iosOutdated-block")
        .addClass("d-block")
        .addClass("d-sm-block")
        .addClass("d-md-block")
        .addClass("d-lg-block")
        .removeClass("d-sm-none")
        .removeClass("d-md-none")
        .removeClass("d-lg-none")
        .removeClass("d-none")
      $(".d-ipad-none").addClass("d-none")
    }
  }
}
export { MacPCView }
